var localizedProductList = function() {
	var categoryTitle = "in ##GROUPNAME##";	
	var colorFilterTitle = " in ##COLORNAME##";
	var greaterThanFormat = "##PRICE## and above";
	var lessThanFormat = "Less than ##PRICE##";
	var priceFilterTitle = ' priced between ##PRICELOW## and ##PRICEHIGH##';
	var productionTimeFilterTitle = 'ships in ##PRODTIME## days';
	var ratingFilterTitle = ' rated ##RATING##';
	var tagFilterTitle = ' in ##TAGNAME##';
	var pageNumberTitle = 'Page ##PAGENUM##';
	var pageSizeTitle = 'Displaying ##PAGESIZE## Products';
	var pageSortTitle = 'Sorted By ##SORTDESC##';
	var subSearchTitle = '';  //we don't currently add the subSearch to the Title
	var selectedPriceRangeFormat = 'From ##min## to ##max##';
	var selectedSubSearchFormat = 'Contains "##search##"';
	var subSearchPlaceHolder = 'Search within these results';
	var newSubSearchPlaceHolder = 'Search for a different term';
	var freeSetupLink = {link: '<a href="/freesetup" class="noLine"><p class="textBlue text13 clear uppercase textsemibold">Free Setup</p></a>', base: '/freesetupitems', title: 'See our products with free setup'};
	var exclusiveLink = {link: '<a href="/exclusive" class="noLine"><p class="textBlue text13 clear uppercase textsemibold">Exclusive</p></a>', base: '/tagitems/80', title: 'See products exclusive to 4imprint'};
	var saleLink = {link:'<a href="/sale" class="noLine"><p class="textRed text13 clear uppercase textsemibold">On Sale!</p></a>', base: '/saleitems', title: 'See our sale products'};
	var closeoutLink = {link:'<a href="/clearance" class="noLine"><p class="textDkRed text13 clear uppercase textsemibold">Clearance</p></a>', base:'/tagitems/129', title: 'See our clearance products'};
	var priceDropLink = {link:'<a href="/pricedrops" class="noLine"><p class="textBlue text13 clear uppercase textsemibold">New Lower Price!</p></a>', base:'/pricedropitems', title:'See our price drop products'};
	var saleTagID = 134;
	var hottestTagID = 252;
	var newTagID = 253;
	
	return {
		CategoryTitle: categoryTitle,
		ColorFilterTitle: colorFilterTitle,
		GreaterThanFormat: greaterThanFormat,
		LessThanFormat: lessThanFormat,
		PriceFilterTitle: priceFilterTitle,
		ProductionTimeFilterTitle: productionTimeFilterTitle,
		RatingFilterTitle: ratingFilterTitle,
		TagFilterTitle: tagFilterTitle,
		PageNumberTitle: pageNumberTitle,
		PageSizeTitle: pageSizeTitle,
		PageSortTitle: pageSortTitle,
		SubSearchTitle: subSearchTitle,
		SelectedPriceRangeFormat: selectedPriceRangeFormat,
		SelectedSubSearchFormat: selectedSubSearchFormat,
		SubSearchPlaceHolder: subSearchPlaceHolder,
		NewSubSearchPlaceHolder: newSubSearchPlaceHolder,
		FreeSetupLink: freeSetupLink,
		ExclusiveLink: exclusiveLink,
		SaleLink: saleLink,
		CloseoutLink: closeoutLink,
		PriceDropLink: priceDropLink,
		SaleTagID: saleTagID,
		HottestTagID: hottestTagID,
		NewTagID: newTagID
	};
};